export class Category {
  constructor(public id: number,
    public name: string,
    public hasSubCategory: boolean,
    public parentId: number,
    public categoryId: number,
    public categoryTitle: string,
    public categoryDescription: string,

  ) { }
}

export class Product {
  constructor(

    public productId: number,
    public productName: string,
    public productImages: Array<any>,
    public productDetails: string,
    public productSpecification: string,
    public availibilityCount: number,
    public cartCount: number,
    public categoryId: number,
    public productPrice: number,
    public cgst: number,
    public sgst: number,
    public igst: number,
    public loggedUserId: number,
    public minValue: number,
    public maxValue: number,
  ) { }
}
export class SearchProduct {
  constructor(public productName: string,
    public categoryName: string,
    public minValue: number,
    public maxValue: number,
  ) { }
}

export class Image {
  constructor(public link: string,
    public preview: string
  ) { }
}

export class Order {
  constructor(
    public userId: number,
    public invoiceToAddress: string,
    public invoiceToCity: string,
    public invoiceToState: string,
    public invoiceToPin: string,
    public invoiceToPhone: string,
    public shipToAddress: string,
    public shipToCity: string,
    public shipToState: string,
    public shipToPin: string,
    public shipToPhone: string,
    public orderItems: Array<any>,
    public taxes: number,   
    public orderTotal: number,
    public productTotal: number,
    public invoiceToGSTINUIN: string
  ) { }
}
export class OrderList {
  constructor(
    public userId: number,
    public invoiceToAddress: string,
    public invoiceToCity: string,
    public invoiceToState: string,
    public invoiceToPin: string,
    public invoiceToPhone: string,
    public shipToAddress: string,
    public shipToCity: string,
    public shipToState: string,
    public shipToPin: string,
    public shipToPhone: string,
    public orderItems: Array<any>,
    public orderTotal: number,
    public productTotal: number,
    public orderDate: Date,
    public poNember: string,
    public shipToGST: number,
    public userName: string) { }
}
export class State {
  constructor(
    public StateID: number,
    public StateName:String){}
}